import { Modal, Backdrop, Fade, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useEffect, useRef, useState } from "react";
import AIGeneratedItemsList from "./AIGeneratedItemsList";
import { normalize } from "../../../utils/llmUtils";
import { IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";


const useStyles = makeStyles(() => ({
   
    modalContentWrapper: {
      background: "#fff",
      borderRadius: "24px",
      padding: "1.5rem",
      width: "60%",
      maxWidth: "800px",
      position: "relative", // IMPORTANT for absolute positioning
    },
    closeButton: {
      position: "absolute",
      top: "12px",
      right: "12px",
    },
  
    header: {
      fontSize: "1.25rem",
      fontWeight: 600,
      marginBottom: "1rem",
    },
  
    listContainer: {
        maxHeight: "500px",
        overflowY: "auto",
        border: "1px solid #ddd",
        borderRadius: "10px",
        padding: "1rem",
        marginBottom: "1.25rem",
    },
    listItem: {
        padding: "0.75rem 1rem",
        borderBottom: "1px solid #eee",
        borderRadius: "8px",
        '&:hover': {
            background: "#f5f5f5",
        }
    },
    buttonRow: {
        display: "flex",
        justifyContent: "flex-end",
        gap: "1rem",
    },
}));

const AiGeneratedItemsModal = ({
    selectedOption,
    items = [],
    onCancel,
    onClose,
    onProceed,
    isLoading,
    messageList,
    title,
    formPlaceholders,
    validationError,
    validations
  }) => {
    
    const classes = useStyles();
    const cancelFn = useRef();
    const [progressMessage, setProgressMessage] = useState([]);
    const [listItems, setListItems ] = useState(normalize({raw: items, entity: selectedOption}));
  
    const modalTitle = title || (selectedOption === "testsuite" ? "Possible Testsuites" : selectedOption === "views" ? "Possible Views" : selectedOption === "database_profile" ? "Possible Database Tables" : "Possible Functionalities") ;
    const listItemType = (selectedOption === "database_profile" || selectedOption === "dbstructure") ? "Table" : selectedOption === "views" ? "View" : selectedOption === "testsuite" ? "Testsuite": "Transaction" 

    const handleProgressMessages = (delay=1000, messages) => {
            let index = 0;
        
            if(index === 0){
              setProgressMessage(messages[index])
            }
        
            const interval = setInterval(() => {
              index++;
              setProgressMessage(index >= messages.length ? messages[messages.length - 1] : messages[index])
            },delay)
        
            const cancel = () => {
              clearInterval(interval)
              setProgressMessage("")
            };
        
            if(index === messages.length - 1){
              cancel()
            }
        
            return cancel;
    }

    const onCloseButtonClick = () => {
      if(isLoading) return;
      onClose();
    }
    
      useEffect(() => {
          if(typeof cancelFn.current === "function") cancelFn.current();
  
          if(isLoading){
            cancelFn.current = handleProgressMessages(2000, messageList);
          }

          return () => {
            if(typeof cancelFn.current === "function") cancelFn.current()
          }
      },[messageList, items, isLoading])
  
    return (
      <Modal
        open={true}
        BackdropComponent={Backdrop}
        BackdropProps={{
          style: {
            backdropFilter: "blur(6px)",
            backgroundColor: "rgba(0,0,0,0.4)",                                         
          },
        }}                                          
        style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
                                                                           
      >
        <Fade in={true}>
          <div className={classes.modalContentWrapper}>
            <IconButton
              className={classes.closeButton}
              onClick={onCloseButtonClick}          
              disabled={isLoading}
            >
              <CloseIcon />
            </IconButton>
            <div className={classes.header}> {modalTitle} </div>
  
            <div className={classes.listContainer}>
              {Array.isArray(listItems) ? (
                <AIGeneratedItemsList items={listItems} setItems={setListItems} entity={listItemType} placeholders={formPlaceholders} validationErrors={validationError} validations={validations}/>
              ) : (
                // String rendering: preserve line breaks and spacing exactly as provided
                <div
                  style={{
                    whiteSpace: "pre-wrap",
                    fontSize: "0.95rem",
                    color: "#333",
                    lineHeight: 1.5,
                  }}
                >
                  {listItems}
                </div>
              )}
            </div>

            {
              isLoading && progressMessage &&
              <div id="progress-message" style={{ color: "#000", fontStyle: "italic", marginTop: "0.5rem", display: 'flex', alignItems: 'flex-end' }}>
                  {progressMessage} 
                  <div style={{paddingLeft: '2px'}}>
                    <span class="dot-loader" aria-label="Loading"></span>
                  </div>
            </div>
            }

            <div className={classes.buttonRow}>
              {selectedOption !== "dbstructure" && 
              <Button variant="outlined" onClick={onCancel} disabled={isLoading ? true : false} >
                Change Prompt
              </Button>
              }

              <Button variant="contained" color="primary" onClick={() =>  onProceed(listItems) } disabled={isLoading}>
                {isLoading ? "Generating.." : "Generate"}
              </Button>
            </div>
          </div>
        </Fade>
      </Modal>
    );
  };
   

export default AiGeneratedItemsModal;
